import init from './init';

export default () => {
  document.addEventListener('shopify:section:load', (e) => {
    init(`[data-section-id="${e.detail.sectionId}"]`);
  });
};
